import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import store from '@/store'
import delayLoad from '@/utils/delayLoad'
import util from '@/utils/util'
import { mobilecheck, isApp } from '@/utils/ua'
import '@/plugin'
import '@/plugin/release'
import '@/config/http'
import 'video.js/dist/video-js.css'
import '@/assets/style/common.scss'
import '@/assets/style/theme.scss'

Vue.use(VueCookies)
try {
  Vue.config.productionTip = false
  if (!window.topicParams.code) {
    alert('专题不存在')
  }

  const code = window.topicParams.channelCode
  if (code) {
    Vue.$cookies.set('channelCode', code, '5min', null, util.getDomain())
  } else {
    Vue.$cookies.remove('channelCode', null, util.getDomain())
  }

  const _platform = mobilecheck() ? isApp() ? 3 : 2 : 1
  Promise.all([
    Vue.user.auth(),
    Vue.topic.getTopic({
      code: topicParams.code,
      status: '1',
      platform: _platform
    })
  ]).then(([userInfo, topic]) => {
    const topicInfo = topic.map && topic.map.topic
    // pc平台加载公共layout
    if (topicInfo && _platform === 1) {
      Vue.layout.initEqxLayout(userInfo.obj)
    }
    topicInfo && (window.topicInfo = topicInfo)
    // 用户登录后，拉取用户的身份状态信息
    if (userInfo.obj) {
      Vue.user.status()
    }
    // 小程序加载微信sdk
    if (parseInt(window.topicParams.platform) === 3) {
      delayLoad.delayLoadJS(Vue.env.plugin.wxapp)
    }
    new Vue({
      store,
      render: h => h(App)
    }).$mount('#app')
  })
} catch (e) {
  console.log(e)
}
